module.exports = __webpack_public_path__ + "img/about_bindu.718a6876.jpg";